<template>
    <ul class="list" :class="cl">
     <!-- approvers 배열을 반복하여 동적 렌더링 -->
     <li 
       v-for="(approver, index) in props.modelValue" 
       :key="index"
       :class="getStatusClass(approver.signState)"
     >
       <div>{{ getStatusText(approver.signState) }}</div>
       <span class="name">{{ approver.userNm }} {{ approver.posNm }}</span>
       <span v-if="isDate" class="date">{{ DateUtil.convertDateData(approver.creDat, true) || '' }}</span>
     </li>
   </ul>
 </template>
 
 <script setup>
 import { defineProps } from 'vue';
 import DateUtil from "@/js/utils/DateUtil";
 
 const props = defineProps({
     modelValue : {
         type : Array,
         },
     cl : {
         type : String,
     },
     isDate :{
        type : Boolean,
        default : true
     }
 
 });
 // 승인자 데이터를 ref로 관리
 
 // 상태별 클래스 반환
 const getStatusClass = (status) => {
   switch (status) {
     case '01': return ''; // 승인 완료
     case '02': return 'red'; // 반려
     case '03': return 'gray ready'; // 승인 대기
     default: return 'gray ready'; // 기본값
   }
 };
 
 // 상태별 텍스트 반환
 const getStatusText = (status) => {
   switch (status) {
     case '01': return '승인 완료';
     case '02': return '반려';
     case '03': return '승인 대기';
     default: return '승인 대기';
   }
 };
 </script>
 
   <!-- 바꾸셔도 됩니당. -->
   <style scoped lang="scss">
     .list {
         display: flex;
         align-items: center;
         gap: 20px;
         >li {
             display: flex;
             flex-direction: column;
             align-items: center;
             justify-content: center;
             gap: 10px;
             >div {
                 position: relative;
                 flex: none;
                 width: 50px;
                 height: 50px;
                 box-sizing: border-box;
                 padding: 0 4px;
                 background-color: $gmx-sub-color;
                 border-radius: 50%;
                 color: $gmx-main-color;
                 font-size: 13px;
                 text-align: center;
                 align-content: center;
                 word-break: keep-all;
                 line-height: 1.1;
                 &:after {
                     content: "";
                     position: absolute;
                     top: 50%;
                     left: -50%;
                     transform: translateX(0);
                     display: block;
                     width: 10px;
                     height: 10px;
                     background-image: url(@/assets/img/icn_right_arrow.png);
                     background-repeat: no-repeat;
                     background-position: center;
                     background-size: contain;
                 }
             }
             >.name {
                 font-size: 14px;
                 text-align: center;
                 white-space: nowrap;
             }
             >.date {
                 font-size: 11px;
                 color: $gmx-font-sub-color2;
             }
             &:first-child {
                 div {
                     &:after {
                         display: none;
                     }
                 }
             }
             &.red {
                 >div {
                     background-color: rgba($state-color0, 0.1);
                     color: $state-color0;
                 }
             }
             &.gray {
                 >div {
                     background-color: rgba($state-color1, 0.1);
                     color: $state-color1;
                 }
             }
             +.ready {
                 & {
                     div {
                         animation: border 2s infinite;
                         @keyframes border {
                             0%, 100% {
                                 border: 4px solid rgba($gmx-theme-color, 0);
                                 box-shadow: 0 3px 6px rgba(0, 0, 0, 0);
                             }
                             50% {
                                 border: 4px solid rgba($gmx-theme-color, 1);
                                 box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
                             }
                         }
                         &:after {
                             animation: move 2s infinite;
                             @keyframes move {
                                 0%, 100% {
                                     transform: translateX(-8px);
                                 }
                                 50% {
                                     transform: translateX(-4px);
                                 }
                             }
                         }
                     }
                 }
             }
         }
     }
     
     .ulcenter{
     justify-content: center;
     background-color: #F6F7FA;
     margin-bottom: 26px;
     >li{
         margin : 22px;
     }
    }

    .small{
        justify-content: center;
       >li {
           >div{
               height:30px;
               width:35px;
               font-size: 10px;
           }
           .name{
            font-size: 10px;
           }
       }
    }
 
   </style>